import { openBlock as r, createElementBlock as e, createStaticVNode as o } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(l, t) {
  return r(), e("svg", a, [...t[0] || (t[0] = [
    o('<path fill="currentColor" d="M12 4H6v16h12V10h1v11H5V3h7z"></path><mask id="a" fill="#fff"><path d="m19 10-7-7v7z"></path></mask><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="m19 10-7-7v7z" mask="url(#a)"></path><path stroke="currentColor" d="M8 13.5h7.5M8 17h7.5"></path>', 4)
  ])]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
